import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";
import { PdfArchiveService } from "@/services";

export class PdfArchiveCreatedNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		let archive = await PdfArchiveService.getArchive(this.Data.id);
		await PdfArchiveService.downloadArchive(archive);
		return {};
	}

	public getIcon():string {
		return "file";
	}

	public getTone():string {
		return "info";
	}

	public getActionKey():string {
		return "download";
	}
}
